import { useEffect, useRef, useState } from "react";
import styles from "./Logs.module.css";
            import load from "../../../../Images/loading.gif";

function Logs() {
    const logRef = useRef(null);
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchLogs = async () => {
            try {
                const response = await fetch("https://eclipsebots.com/api/logs/get", {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    credentials: "include"
                });

                if (!response.ok) {
                    throw new Error("Failed to fetch logs");
                }

                const data = await response.json();

                setLogs(data);
            } catch (error) {
                console.error("Erro ao buscar logs:", error);
                setLogs([]);
            } finally {
                setLoading(false);
            }
        };

        fetchLogs();

        if (logRef.current) {
            logRef.current.scrollTop = logRef.current.scrollHeight;
        }
    }, []);

    
        if (loading) {
            return <div className={styles.content}>
                <div className={`${styles.size} ${styles.loading}`}>
                    <img src={load} width="20px" height="20px" alt="loading" />
                </div>
            </div>
        }

    return (
        <div className={styles.logsBox}>
            <div className={styles.log}>
                {logs.length === 0 && (
                    <div className={styles.print}>Não há nenhuma log disponível</div>
                )}
                {logs.map((log, index) => {
                    const createdDate = new Date(log.created);
                    let created = createdDate.toLocaleString("pt-PT", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                    }).replace(",", " |");

                    return (
                        <div key={log.logId} className={styles.print}>
                            <span className={styles.time}>[{created}]</span> {log.description}
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default Logs;